import isFeatureToggleOn from '@javascripts/utils/feature_toggle';
import { PlayerEnvironment } from '../player_environment';
import LocationAdapter from '@javascripts/adapters/location_adapter';

export default class VP9Reloader {
  static shouldInit({ data } = {}) {
    return (
      data.isLivestreaming() &&
      !data.drmEnabled() &&
      data.vjsClipDashUrl() !== '' &&
      PlayerEnvironment.isSupportVp9() &&
      !PlayerEnvironment.isForcedToUseHLS() &&
      LocationAdapter.search().skip_ls_vp9_fix !== 'true' &&
      !isFeatureToggleOn('disable_vp9_reloader')
    )
  }

  constructor(options = {}) {
    this._tech = options.tech;
    this._restarted = false;
    this._timeout = null;
  }

  tech() {
    return this._tech;
  }

  init() {
    this.onLivestreamingBufferListener();
  }

  onLivestreamingBufferListener() {
    this.tech().on('bufferstart', () => {
      if(!this._restarted) this.onLivestreamingBufferHandler();
    });
  }

  onLivestreamingBufferHandler() {
    if (this._timeout) return;
 
    this._timeout = setTimeout(this.restartSource.bind(this), 3000);

    this.tech().on('bufferend', () => {
      clearTimeout(this._timeout);
      this._timeout = null;
    });
  }

  restartSource() {
    const isPaused = this.tech().paused();
    const src = this.tech().currentSrc();

    this.tech().plugin().instance().src(src);
    this._timeout = null;
    this._restarted = true;

    if(!isPaused) this.tech().play();
  }
}
